/* ==========================================================================
   MOBILE CARD GENERATOR (/database/js/card-mobile.js)
   Desktop-parity feature set with mobile-specific composition.
   ========================================================================== */

import { escapeHtml } from '../utils.js?v=20260819-audit2';
import { isSingleCaseUrlView } from '../seo.js?v=20260822-audit3';
import { state } from '../state.js?v=20260819-audit2';
import {
  getCaseCardViewModel, renderModeSelectorHtml, renderFormFactorSummaryHtml,
  renderClearancePanelHtml, renderSecondaryDataHtml, renderLayerBarHtml
} from './card-shared.js?v=20260819-audit2';

export function renderMobileCard(c, idx) {
  const singleCaseMode = isSingleCaseUrlView();
  const isCompareMode = state.sffPinnedCases.length === 2;
  const cardType = singleCaseMode ? 'single' : (isCompareMode ? 'compare' : 'feed');
  const vm = getCaseCardViewModel(c, idx, { cardType, surface: 'mobile' });
  const escapedName = escapeHtml(vm.formattedTitle);
  const escapedImg = escapeHtml(c.image);
  const lazyDrawersMarkup = cardType === 'feed' ? '' : `
    <div class="ws-community-builds-drawer font-mono" id="${vm.buildsDrawerId}" style="display:none;" aria-hidden="true"></div>
    <div class="ws-reviews-drawer font-mono" id="${vm.reviewsDrawerId}" style="display:none;" aria-hidden="true"></div>`;

  const imageMarkup = singleCaseMode
    ? `<div class="card-image-wrapper"><img data-src="${escapedImg}" src="/assets/images/placeholder.webp" alt="${escapedName}" class="case-thumb lazy-img-node" onerror="this.onerror=null;this.src='/assets/images/placeholder.webp';"></div>`
    : `<a class="card-image-wrapper ws-case-nav-link" href="${vm.href}" data-slug="${vm.slug}" title="Open ${escapedName} case page"><img data-src="${escapedImg}" src="/assets/images/placeholder.webp" alt="${escapedName}" class="case-thumb lazy-img-node" onerror="this.onerror=null;this.src='/assets/images/placeholder.webp';"></a>`;

  const titleMarkup = singleCaseMode
    ? `<h3 class="case-name-static">${escapedName}</h3>`
    : `<a class="case-name-static ws-case-nav-link" href="${vm.href}" data-slug="${vm.slug}" title="Open ${escapedName} case page">${escapedName}</a>`;

  const div = document.createElement('div');
  div.className = `case-card card-mobile ${vm.isSelected ? 'selected-case' : ''} ${vm.isPinned ? 'pinned-case' : ''} ${singleCaseMode ? 'single-case-focus' : ''}`;
  div.id = `card-${idx}`;
  if (vm.broadNavigation) div.setAttribute('data-card-nav-slug', vm.slug);
  div.setAttribute('data-card-type', cardType);

  div.innerHTML = `
    <div class="case-card-body">
      <div class="card-main-row">
        <div class="card-left-column">${imageMarkup}</div>

        <div class="card-core-details">
          <div class="case-title-row">
            ${titleMarkup}

            <div class="mobile-card-toolbar font-mono">
              <button type="button" class="sff-pin-card-btn ${vm.isPinned ? 'active-pin' : ''}" data-pin-idx="${idx}">
                <svg class="sff-svg-icon" viewBox="0 0 24 24" fill="${vm.isPinned ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
                <span>${vm.isPinned ? 'PINNED' : 'PIN'}</span>
              </button>
              <button type="button" class="sff-validate-card-btn ${vm.isSelected ? 'selected' : ''}" data-idx="${idx}">
                <svg class="sff-bolt-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                <span>${singleCaseMode && vm.isSelected ? 'GENERATE REPORT' : 'VALIDATE'}</span>
              </button>
              <a class="case-external-action-link ${vm.linkClass}" href="${vm.safeUrl}" target="_blank" rel="noopener noreferrer">
                <span>${vm.linkText}</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
              </a>
            </div>

            <div class="sidebar-badge-stack">
              <span class="status-label status-badge fits">FITS</span>
              <span class="tag-badge volume-display-tag">${escapeHtml(c.volume)}L</span>
              <span class="status-badge purple-layout">${escapeHtml(vm.layoutTag)}</span>
              ${c.hasSpine ? '<span class="status-badge spine-badge">ADJ SPINE</span>' : ''}
              ${vm.hasModes ? `<span class="status-badge mode-badge">${c.modes.length} MODES</span>` : ''}
              ${c._isLegacy ? '<span class="status-badge legacy-badge">LEGACY</span>' : ''}
            </div>
          </div>
        </div>
      </div>

      ${renderModeSelectorHtml(vm)}
      ${renderFormFactorSummaryHtml(vm)}
      ${renderClearancePanelHtml(vm)}
      ${renderSecondaryDataHtml(vm)}
      ${renderLayerBarHtml(vm)}
    </div>

    ${lazyDrawersMarkup}

    <div class="spine-status-bar-restored" id="spine-bar-${idx}">
      <span class="spine-mode-title" id="spine-title-${idx}">Adjustable Spine Mode Active</span>
      <span class="spine-mode-specs" id="spine-specs-${idx}"></span>
    </div>

    <div class="card-footer-stack"><p class="diagnostic-log"></p></div>
  `;

  return div;
}
